<template>
  <div class="w-full flex flex-col">
    <div class="bg-n-100 dark:bg-n-900 flex items-center px-5 pb-3 gap-2">
      <l-icon name="bracket-left" class="text-v-300 cursor-pointer" @click="$emit('back')" />
      <span class="font-heading font-medium leading-4">{{ t('configuration.settings') }}</span>
    </div>
    <div class="flex-1 flex flex-col px-5 overflow-hidden pb-safe">
      <div
        class="flex items-center justify-between border-b border-n-50 dark:border-n-700 py-4 text-sm"
      >
        {{ t('configuration.sound-effects') }}
        <l-switch :model-value="!mute" @update:model-value="mute = !$event" />
      </div>

      <div class="py-4 border-b border-n-50 dark:border-n-700">
        <div class="text-sm mb-2">{{ t('configuration.font-size') }}</div>
        <div class="flex items-center gap-2 py-2">
          <div class="text-[11px]">{{ t('configuration.letter-size') }}</div>
          <slider :points="[12, 14, 16, 18, 20]" v-model="fontSize" />
          <div class="text-[20px]">{{ t('configuration.letter-size') }}</div>
        </div>
      </div>

      <div class="py-3">
        <p class="text-sm mb-2">
          {{ t('configuration.theme') }}
        </p>
        <l-option-selector v-model="darkMode" :options="themeList" class="w-full" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { LIcon, LOptionSelector, LSwitch } from '@last/core-ui/paprika'

import { useConfigStore } from '@/store/config'

import Slider from './Slider.vue'

defineEmits<{
  back: []
}>()

const { t } = useI18n()

const configStore = useConfigStore()
const { mute, fontSize, darkMode } = storeToRefs(configStore)

const themeList = computed(() => [
  {
    label: t('sidemenu.theme.light'),
    value: false
  },
  {
    label: t('sidemenu.theme.dark'),
    value: true
  }
])
</script>
